import { DollarSign, Target, Shield, Zap, BarChart, TrendingUp, Award } from 'lucide-react';

const differentiators = [
  {
    icon: DollarSign,
    title: 'Higher Payouts',
    description: 'We pay out maximum profit as our triple net leases mean tenants cover all expenses, removing the need to retain cash for maintenance.',
  },
  {
    icon: Target,
    title: 'Specific, Tangible Investments',
    description: 'Invest in specific properties you know and understand, not a complex bundle of assets.',
  },
  {
    icon: Shield,
    title: 'Direct Investor Control',
    description: 'You have a direct say in which properties you buy or sell, unlike REITs where fund managers make all the decisions.',
  },
  {
    icon: Zap,
    title: 'Lower Volatility',
    description: 'Our assets aren’t marked to market daily like REITs, making them less volatile and less subject to market sentiment.',
  },
  {
    icon: BarChart,
    title: 'Exclusive Off-Market Deals',
    description: 'We source exclusive, off-market deals that are often superior to what investors could find on their own.',
  },
  {
    icon: TrendingUp,
    title: 'More Frequent Dividends',
    description: 'We pay dividends quarterly, providing a more regular income stream compared to most REITs which pay bi-annually.',
  },
  {
    icon: Award,
    title: 'Greater Tax Efficiency',
    description: 'Our returns are structured for tax efficiency, unlike REIT distributions which are taxed at your marginal income tax rate.',
  },
];

const DifferentiatorsSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900">A Smarter Way to Invest in Property</h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
            ALTA-X was built to outperform traditional real estate investments like REITs. Here’s how we provide more value, control, and transparency to our investors.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {differentiators.map((item, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300 border border-gray-200">
              <div className="flex items-center justify-center h-12 w-12 rounded-full bg-[hsl(var(--navy))] text-white mb-6">
                <item.icon className="h-6 w-6" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{item.title}</h3>
              <p className="text-gray-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DifferentiatorsSection;
